
      import PendingPay from './pending-pay.vue'
      import type { App, Plugin } from 'vue'

      export const PendingPayPlugin: Plugin = {
        install(app: App) {
          app.component('PendingPay', PendingPay)
        },
      }
      export { PendingPay }
      